
/*
 * Filters functionality
 */


// Global vars
var biro_filters_form;


// On page load
jQuery( function( $ ) {

	// Init
	biro_filters_form = $( '.filters-form' );

	// Form events
	biro_filters_form.on( 'change', 'select,input[type="radio"]', function() {

		// Submit when filter is changed
		biro_filters_form.submit();

	}).on( 'keypress', 'label.filters-focusable', function( e ) {

		// 'Enter' keypress event on radio labels
		// Needed because visual styling of field (labels) lacks visual queue that it's radio
		// Which normally would be tabbed into, then arrow keys used to move between options
		// (which changes field and submits straight away)
		if ( e.which === 13 ) {

			// Select option and submit form
			$( '#' + $( this ).attr( 'for' ) ).prop( 'checked', true );
			biro_filters_form.submit();

		}

	});



});